var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sr-button',{staticClass:"hidden md:flex",attrs:{"icon":_vm.icon,"text":_vm.text,"short":true,"emphasis":"high"},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }